import React from 'react'
import HeaderRenderer from '../components/HeaderRenderer'
import initialState from '../store/initialState'
import entriesTypes from '../constants/entriesTypes'
import reportsTypes from '../constants/reportsTypes'
import {capitalize} from '../helpers'
import Editor from '../components/Editor'

const { toast } = window.M

export default function entriesReducer(state = initialState.entries, action) {
  switch (action.type) {

    case entriesTypes.reset_errors:
      return {
        ...state,
        errors: []
      }

    case entriesTypes.set_filters:
      return {
        ...state,
        filters: action.payload
      }

    case entriesTypes.batch_update.request: {
      return {
        ...state,
        fetching: true,
        fetched: false
      }
    }

    case entriesTypes.batch_update.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    case entriesTypes.dry_batch_update.request: {
      return {
        ...state,
        running_bulk: false,
        ran_bulk: true,
        dry: null
      }
    }

    case entriesTypes.dry_batch_update.success: {

      return {
        ...state,
        running_bulk: true,
        ran_bulk: false,
        dry: action.payload.dry
      }
    }

    case entriesTypes.dry_batch_update.failure: {
      toast({
        html: "Error on trying to run batch operations"
      })
      return {
        ...state,
        running_bulk: false,
        ran_bulk: false,
        errors: action.payload
      }
    }

    case entriesTypes.dry_batch_update.reset: {
      return {
        ...state,
        running_bulk: false,
        ran_bulk: false,
        dry: null
      }
    }

    // entriesTypes.batch_update.success
    // is entriesTypes.index.success

    case entriesTypes.bulk_rows.request:
      return {
        ...state,
        running_bulk: true,
        ran_bulk: false
      }

    case entriesTypes.multiple_mark_read.success:{
      const {entries} = action.payload
      const ids = Object.keys(entries)
      return {
        ...state,
        running_bulk: false,
        ran_bulk: false,
        items: state.items.map( (item) => {
          if ( ids.indexOf(item.id) < 0) {
            return item
          } else {
            return {
              ...item,
              newentry: entries[item.id],
              status: (entries[item.id]) ? "New" : ((item.removed === true) ? "Removed" : '')
            }
          }
        })
      }
    }

    case entriesTypes.multiple_publish.success:{
      const {entries} = action.payload
      const ids = Object.keys(entries)
      return {
        ...state,
        running_bulk: false,
        ran_bulk: false,
        items: state.items.map( (item) => {
          if ( ids.indexOf(item.id) < 0) {
            return item
          } else {
            return {
              ...item,
              published: entries[item.id]
            }
          }
        })
      }
    }

    case entriesTypes.multiple_unpublish.success:{
      const {entries} = action.payload
      const ids = Object.keys(entries)
      return {
        ...state,
        running_bulk: false,
        ran_bulk: true,
        items: state.items.map( (item) => {
          if ( ids.indexOf(item.id) < 0) {
            return item
          } else {
            return {
              ...item,
              published: entries[item.id]
            }
          }
        })
      }
    }

    case entriesTypes.bulk_rows.failure:
      return {
        ...state,
        running_bulk: true,
        ran_bulk: false
      }


    case entriesTypes.add_columns.request:
      return {
        ...state,
        adding_columns: true,
        removing_column: true,
        added_columns: false
      }

    case entriesTypes.duplicate_row.request:
      return {
        ...state,
        duplicating_row: true,
        duplicated_row: false
      }

    case entriesTypes.duplicate_row.success:{
      const {data, rowId} = action.payload
      const {
        entry,
        // place_after
      } = data
      return {
        ...state,
        duplicating_row: false,
        duplicated_row: true,
        items: [
          ...state.items.slice(0, rowId+1),
          entry,
          ...state.items.slice(rowId+1)
        ]
      }
    }

    case entriesTypes.duplicate_row.failure:
      return {
        ...state,
        duplicating_row: false,
        duplicated_row: false,
        errors: action.payload
      }

    case entriesTypes.mark_read.request:
      return {
        ...state,
        publishing_row: true,
        published_row: false
      }

    case entriesTypes.mark_read.success: {
      const {data, rowId} = action.payload
      const {
        entry
      } = data
      return {
        ...state,
        publishing_row: false,
        published_row: true,
        items: [
          ...state.items.slice(0, rowId),
          entry,
          ...state.items.slice(rowId+1)
        ]
      }
    }

  case entriesTypes.mark_read.failure:
    return {
      ...state,
      publishing_row: false,
      published_row: false
    }

    case entriesTypes.publish_row.request:
      return {
        ...state,
        publishing_row: true,
        published_row: false
      }

    case entriesTypes.publish_row.success: {
      const {data, rowId} = action.payload
      const {
        entry
      } = data
      return {
        ...state,
        publishing_row: false,
        published_row: true,
        items: [
          ...state.items.slice(0, rowId),
          entry,
          ...state.items.slice(rowId+1)
        ]
      }
    }

    case entriesTypes.publish_row.failure:
      return {
        ...state,
        publishing_row: false,
        published_row: false
      }

    case entriesTypes.unpublish_row.request:
      return {
        ...state,
        unpublishing_row: true,
        unpublished_row: false
      }

    case entriesTypes.unpublish_row.success: {
      const {data, rowId} = action.payload
      const {
        entry
      } = data
      return {
        ...state,
        unpublishing_row: false,
        unpublished_row: true,
        items: [
          ...state.items.slice(0, rowId),
          entry,
          ...state.items.slice(rowId+1)
        ]
      }
    }

    case entriesTypes.unpublish_row.failure:{
      return {
        ...state,
        unpublishing_row: false,
        unpublished_row: false
      }
    }

    // case entriesTypes.set_counters.success: {
    //   // const counterFields = action.payload.counters.map( c=> c.key )
    //   const keys = state.keys.map( k => {
    //     // const newHasCounter = counterFields.indexOf(k.key) < 0 ? false : true
    //
    //     const newCounter = action.payload.counters.find( c => c.key === k.key )
    //     const threshold  = newCounter ? newCounter.value : -1
    //     console.log(threshold)
    //     const newHasCounter = newCounter !== undefined
    //
    //     const formatter_with = (props)=>(<div><i className={`${(threshold < 0 || (props.value && props.value.toString().length <= threshold)) ? '' : 'visibleClass'} material-icons c-red problem_icon`}>report_problem</i>{props.value}</div>)
    //     const formatter_without = (props)=>(<div>{props.value}</div>)
    //
    //     const {hasCounter, formatter, ...other} = k
    //     const newFormatter = newHasCounter ? formatter_with : formatter_without
    //       // formatter_with : formatter_without
    //
    //     return {
    //       ...other,
    //       hasCounter: newHasCounter,
    //       formatter: newFormatter
    //     }
    //   })
    //
    //   return {
    //     ...state,
    //     counters: action.payload.counters,
    //     keys: keys,
    //     adding_columns: false,
    //     removing_column: false,
    //     added_columns: true,
    //   }
    // }

    case entriesTypes.add_columns.success:
      const current_keys = state.keys.map( key => {
        return key.key
      })
      return {
        ...state,
        keys: action.payload.keys.map((key) => {
          const newkey = key
          if ( current_keys.indexOf(newkey) === -1 ) {
            const titles = ["title_1", "title_2"]
            if ( titles.indexOf(key) > -1 ) {
              return {
                key: key, headerRenderer: <HeaderRenderer field={key} name={capitalize(key)}/>,
                name: capitalize(key), resizable: true, sortable: true, editable: true,
                hidden: false, cellClass: 'no-overflow', width: 300,
                editor: <Editor />
              }
            } else {
              return {
                key: key, name: capitalize(key), resizable: true, sortable: true,
                editable: true, hidden: false, editor: <Editor />, cellClass: 'no-overflow'
              }
            }
          } else {
            return state.keys.find( (stateKey) => stateKey.key === key )
          }
        }),
        removed_keys: action.payload.removed_keys,
        adding_columns: false,
        removing_column: false,
        added_columns: true,
        xml_status: 'outofsync'
      }

    case entriesTypes.add_columns.failure:
      return {
        ...state,
        added_columns: false,
        errors: action.payload
      }


    case entriesTypes.set_sorting:
      return {
        ...state,
        sort: action.payload.sort,
        order: action.payload.order
      }

    case entriesTypes.title_length.show:
      return {
        ...state,
        keys: state.keys.map(key => {
          if (key.key === "title_length") {
            return {
              ...key,
              hidden: false,
              width: 120
            }
          } else {
            return key;
          }
        })
      }

    case entriesTypes.title_length.hide:
      return {
        ...state,
        keys: state.keys.map(key => {
          if (key.key === "title_length") {
            return {
              ...key,
              hidden: true,
              width: 0
            }
          } else {
            return key;
          }
        })
      }

    case reportsTypes.restore.success_minimal:
      return {
        ...state,
        report_id: action.payload.report_id,
        report_name: action.payload.report_name,
        master_name: action.payload.master_name,
        master_id: action.payload.master_id,
        xml_url: action.payload.xml_url,
        xml_pending: action.payload.xml_pending,
        xml_status: action.payload.xml_status,
        xml_updating: action.payload.updating,
        published: action.payload.published,
        trash: action.payload.trash,
        master_trash: action.payload.master_trash
      };


    case reportsTypes.publish.success_minimal:
      return {
        ...state,
        report_id: action.payload.report_id,
        report_name: action.payload.report_name,
        master_name: action.payload.master_name,
        master_id: action.payload.master_id,
        xml_url: action.payload.xml_url,
        xml_pending: action.payload.xml_pending,
        xml_status: action.payload.xml_status,
        xml_updating: action.payload.xml_updating,
        published: action.payload.published,
        trash: action.payload.trash,
        master_trash: action.payload.master_trash
      };

    case reportsTypes.update_xml.success_minimal:
      return {
        ...state,
        report_id: action.payload.report_id,
        report_name: action.payload.report_name,
        master_name: action.payload.master_name,
        master_id: action.payload.master_id,
        xml_url: action.payload.xml_url,
        xml_pending: action.payload.xml_pending,
        xml_status: action.payload.xml_status,
        xml_updating: action.payload.xml_updating,
        published: action.payload.published,
        trash: action.payload.trash,
        master_trash: action.payload.master_trash
      };

    case reportsTypes.unpublish.success_minimal:
      return {
        ...state,
        report_id: action.payload.report_id,
        report_name: action.payload.report_name,
        master_name: action.payload.master_name,
        master_id: action.payload.master_id,
        xml_url: action.payload.xml_url,
        xml_pending: action.payload.xml_pending,
        xml_status: action.payload.xml_status,
        xml_updating: action.payload.xml_updating,
        published: action.payload.published,
        trash: action.payload.trash,
        master_trash: action.payload.master_trash
      };

    case reportsTypes.get.success_minimal:
      return {
        ...state,
        report_id: action.payload.report_id,
        report_name: action.payload.report_name,
        master_name: action.payload.master_name,
        master_id: action.payload.master_id,
        xml_url: action.payload.xml_url,
        xml_pending: action.payload.xml_pending,
        xml_status: action.payload.xml_status,
        xml_updating: action.payload.xml_updating,
        published: action.payload.published,
        trash: action.payload.trash,
        master_trash: action.payload.master_trash
      };

    case entriesTypes.index.request:
      return {
        ...state,
        fetching: true,
        fetched: false
      };

    case entriesTypes.index.page_request:
      return {
        ...state,
        fetching_page: true,
        fetched: false
      };

    case entriesTypes.set_counters.success:
    case entriesTypes.index.success:
      const noneditable = ["address", "removed", "title_length", "created_at", "updated_at", "published", "status"]
      const hidden = ["title_length"]
      const { counters } = action.payload
      const keys = []
      action.payload.keys.filter(k => !k.match(/_length$/)).forEach((key) => {
        const wrappable = []
        // const wrappable = ["description", "title", "title_1", "title_2", "link"]
        const dateable = ["created_at", "updated_at"]
        const editable = ( noneditable.indexOf(key) < 0 )
        const is_hidden = ( hidden.indexOf(key) > -1 )
        if (is_hidden) {
          let was_hidden = true
          if (state.keys !== undefined && state.keys !== null && state.keys.length > 0) {
            const thisKey = state.keys.find( (stateKey) => stateKey.key === key )
            was_hidden = thisKey.hidden
          }

          keys.push({
            key: key, headerRenderer: <HeaderRenderer field={key} name={capitalize(key)}/>,
            name: capitalize(key), resizable: true, sortable: true, editable: editable, listable: editable,
            hidden: was_hidden, width: was_hidden ? 0 : 150
          })
        } else {
          if ( dateable.indexOf(key) > -1 ) {
            keys.push({
              key: key, headerRenderer: <HeaderRenderer field={key} name={capitalize(key)}/>,
              name: capitalize(key), resizable: true, sortable: true, editable: false, listable: editable,
              hidden: false, width: 150,
              formatter: (props)=>(<div>{props.value ? new Date(props.value).toLocaleDateString() + ' ' + new Date(props.value).toLocaleTimeString() : ''}</div>)
            })
          } else if ( wrappable.indexOf(key) > -1 ) {
            const colwidth = (key === "description") ? 400 : 300
            keys.push({
              key: key, headerRenderer: <HeaderRenderer field={key} name={capitalize(key)}/>,
              name: capitalize(key), resizable: true, sortable: true, editable: editable, listable: editable,
              hidden: false, cellClass: 'no-overflow', width: colwidth,
              editor: editable ? <Editor /> : ''
            })
          } else if ( key === "published" ) {
            keys.push({
              key: key, headerRenderer: <HeaderRenderer field={key} name="Visibility"/>,
              name: "Published", resizable: true, sortable: true, editable: editable, listable: true,
              hidden: true, width: 0,
              formatter: (props)=>{
                const published = (props.value !== false)
                if (published) {
                  return <div className="rowPublished"><span>PUBLISHED</span></div>
                } else {
                  return <div className="rowUnpublished"><span>UNPUBLISHED</span></div>
                }
              }
            })
          } else if ( key === "newentry" ) {
            keys.push({
              key: key, hidden: true, width: 0,
              name: "New Entry", resizable: false, sortable: false, editable: false, listable: true
            })
          } else if ( key === "removed" ) {
            keys.push({
              key: key, hidden: true, width: 0,
              name: "Removed Entry", resizable: false, sortable: false, editable: false, listable: true
            })
          } else if ( key === "status" ) {
            keys.push({
              key: key, headerRenderer: <HeaderRenderer field={key} name="Status"/>,
              name: "Status", resizable: true, sortable: true, editable: editable, listable: editable,
              hidden: true, width: 0,
              formatter: (props)=>{
                if ( props.value === "New" ) {
                  return <div className="rowNew"><span>NEW</span></div>
                } else if ( props.value === "Removed" ) {
                  return <div className="rowRemoved"><span>REMOVED</span></div>
                } else {
                  return <div />
                }
              }
            })
          } else {
            const colwidth = 150
            // if (key === "sku") {
            //   keys.push({
            //     key: key, headerRenderer: <HeaderRenderer field={key} name={capitalize(key)}/>,
            //     name: capitalize(key), resizable: true, sortable: true, editable: editable, listable: editable,
            //     hidden: false, width: colwidth,
            //     formatter: (props)=>(<div><i className="material-icons c-red problem_icon">report_problem</i>{props.value}</div>)
            //   })
            // } else {
            const hasCounter = action.payload.counters.find( c => c.key === key )
            const threshold  = hasCounter ? hasCounter.value : -1
            keys.push({
              key: key, headerRenderer: <HeaderRenderer field={key} name={capitalize(key)}/>, hasCounter: hasCounter!==undefined,
              name: capitalize(key), resizable: true, sortable: true, editable: editable, listable: editable,
              hidden: false, width: colwidth, editor: editable ? <Editor /> : '', cellClass: 'no-overflow',
              formatter: (props)=>(
                <div title={(threshold < 0 || !props.value || props.value.length <= threshold) ? '' : `'${capitalize(key)}' is longer than the allowed threshold of ${threshold} characters`}>
                  <i className={`${(threshold < 0 || !props.value || props.value.length <= threshold) ? '' : 'visibleClass'} material-icons c-red problem_icon`}>report_problem</i>
                  {props.value}
                </div>)
            })
            if (hasCounter) {
              const ckey = `${key}_length`
              keys.push({
                key: ckey, headerRenderer: <HeaderRenderer field={ckey} name={capitalize(ckey)}/>, hasCounter: false,
                name: capitalize(ckey), resizable: true, sortable: true, editable: false, listable: false,
                hidden: false, width: 100, editor:'', cellClass: 'no-overflow',
                formatter: (props)=> (<div>{(props.row[key] || '').length}</div>)
              })
            }
            // }
          }
        }
      }) //forEach

      return {
        ...state,
        fetching: false,
        fetched: true,
        account_id: action.payload.account_id,
        report_id: action.payload.report_id,
        report_name: action.payload.report_name,
        master_name: action.payload.master_name,
        master_id: action.payload.master_id,
        published: action.payload.published,
        trash: action.payload.trash,
        master_trash: action.payload.master_trash,
        xml_url: action.payload.xml_url,
        xml_pending: action.payload.xml_pending,
        xml_status: action.payload.xml_status,
        xml_updating: action.payload.xml_updating,
        items: action.payload.entries,
        pagination: action.payload.pagination,
        sort: '',
        order: '',
        counters: action.payload.counters,
        removed_keys: action.payload.removed_keys,
        keys: keys
      };

    case entriesTypes.index.page_success:
      return {
        ...state,
        fetching_page: false,
        fetched: false,
        pagination: action.payload.pagination,
        items: [ ...state.items, ...action.payload.entries]
      };

    case entriesTypes.index.sorted_request:
      return {
        ...state,
        fetching_sorted: true,
        items: [],
        fetched: false
      };

    case entriesTypes.index.sorted_success:
      return {
        ...state,
        fetching_sorted: false,
        fetched: true,
        pagination: action.payload.pagination,
        items: action.payload.entries
      }

    case entriesTypes.index.sorted_failure:
      return {
        ...state,
        fetching_sorted: false,
        fetched: false
      };



    case entriesTypes.index.failure:
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }

    case entriesTypes.um.request:
      return {
        ...state,
        updating: true
      };

    case entriesTypes.um.success:
      const {ids, values} = action.payload
      const updatedItems = state.items.map(item => {
        if ( ids.indexOf(item.id) > -1 ){
          return { ...item, ...values[item.id] }
        }
        return item
      })
      return {
        ...state,
        updating: false,
        items: updatedItems
      };

    case entriesTypes.um.failure:
      return {
        ...state,
        updating: false,
        errors: action.payload
      }

    case entriesTypes.um.set_icon:
      if (state.published === true) {
        return {
          ...state,
          xml_status: 'outofsync'
        }
      } else {
        return state
      }


    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/entriesReducer.js